/**
 * 生成对账单 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import model from '@/reducers/finance/accountstatement/model';
import { XScrollSelect } from '@/components/xqxc_ui';
import { Modal, Input, Form, DatePicker, message, Select, Alert } from 'antd';
import styles from './ManualPay.module.scss';

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
const { Option } = Select;
class NoLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            title: this.props.title,
            visible: this.props.visible,
            shopObj: {},
            dates: []
        };
    }
    componentDidMount() {
        // this.props.getOpearationList();
    }
    formRef = React.createRef();
    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then(async (fieldsValue) => {
            const { shopObj } = this.state;
            let startDate = fieldsValue.date[0].format('YYYY-MM-DD'),
                endDate = fieldsValue.date[1].format('YYYY-MM-DD');
            let param = {
                targetId: shopObj.targetId,
                targetName: shopObj.targetName,
                remark: fieldsValue.remark,
                startDate,
                endDate,
                type: 'OPERATION',
                targetType: 'OPERATION'
            };
            http('/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.generateReconciliation', param).then(res => {
                message.success('操作成功!');
                this.setState({ visible: false });
                this.props.closeModal(true);
            }).catch((res) => {
                message.error(res.message);
                this.setState({ visible: false });
                this.props.closeModal();
            });
        });
    };
    handleChange = (e, obj) => {
        this.setState({ shopObj: obj });
    }
    // 点击取消
    _handleCancel = () => {
        this.setState({ visible: false });
        this.props.closeModal();
    }
    disabledDate = current => {
        const { dates } = this.state;
        if (!dates || dates.length === 0) {
            return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') > 70;
        const tooEarly = dates[1] && dates[1].diff(current, 'days') > 70;
        return tooEarly || tooLate;
    };
    onChange = e => {
        this.setState({ value: e });
    }
    onDatesChange = e => {
        this.setState({ dates: e });
    }
    onOpenChange = open => {
        if (open) {
            this.setState({ hackValue: [], dates: [] });
        } else {
            this.setState({ hackValue: undefined });
        }
    };
    render() {
        const { visible, confirmLoading, title, shopObj = {}, value, hackValue } = this.state;
        const { dataList = [] } = this.props.OpearationList;
        return (
            <Modal
                width={610}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Alert message="按起止日期生成对账单，最大间隔天数为70天；" type="error" style={{ marginBottom: 10, textAlign: 'left' }} />
                    <Form {...formItemLayout} name="control-ref" ref={this.formRef}>
                        <Form.Item
                            label='企业名称'
                            name='targetId'
                            rules={[{ required: true, message: '请选择企业名称' }]}
                        >
                            <XScrollSelect
                                style={{ width: 450, textAlign: 'left' }}
                                url='/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.getOpearationList'
                                placeholder='请选择企业名称'
                                showSearch
                                mainKey='targetName'
                                selectID='targetId'
                                selectName='targetName'
                                value={shopObj || {}}
                                listLabel='dataList'
                                isOptionBindID={true}
                                onChange={(value, item) => this.setState({ shopObj: item.props['data-option'] })}
                            />
                            {/* <Select
                                showSearch
                                style={{ width: 450, textAlign: 'left' }}
                                placeholder="请选择企业名称"
                                onChange={this.handleChange}
                                // options={OpearationList}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {dataList && dataList.map(i => {
                                    return <Option value={i.targetId}>{i.targetName}</Option>
                                })}
                            </Select> */}
                        </Form.Item>
                        <Form.Item
                            label='起止日期'
                            name='date'
                            rules={[{ required: true, message: '请选择起止日期' }]}
                        >
                            <RangePicker
                                style={{ width: 450, marginLeft: 10 }}
                                value={hackValue || value}
                                disabledDate={this.disabledDate}
                                onCalendarChange={this.onDatesChange}
                                onChange={this.onChange}
                            // onOpenChange={this.onOpenChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label='备注'
                            name='remark'
                        >
                            <TextArea rows={4} style={{ marginLeft: 10 }} />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

NoLogin.propTypes = {
    data: PropTypes.object, // 弹框入参
    form: PropTypes.object,
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
    getOpearationList: PropTypes.func,
    OpearationList: PropTypes.array
};
const mapStateToProps = (state) => ({
    OpearationList: state.accountstatement.OpearationList,
});

export default connect(mapStateToProps, { ...model.actions })(NoLogin);